module.exports = __webpack_public_path__ + "img/logo_w_title.7adf8856.svg";